<template>
  <div class="admin-dashboard">
    <el-container>
      <el-header>
        <div class="header-content">
          <h1>婚纱摄影管理系统</h1>
          <div class="header-actions">
            <el-button type="text" @click="goToChangePassword">
              <i class="el-icon-lock"></i> 修改密码
            </el-button>
            <el-button type="text" @click="handleLogout">
              <i class="el-icon-switch-button"></i> 退出登录
            </el-button>
          </div>
        </div>
      </el-header>
      <el-main>
        <el-row :gutter="20">
          <el-col :span="8">
            <el-card class="box-card">
              <div slot="header" class="clearfix">
                <span>分类管理</span>
              </div>
              <div class="card-content">
                <p>管理三级分类结构</p>
                <el-button type="primary" @click="goToCategories">进入分类管理</el-button>
              </div>
            </el-card>
          </el-col>
          <el-col :span="8">
            <el-card class="box-card">
              <div slot="header" class="clearfix">
                <span>资源管理</span>
              </div>
              <div class="card-content">
                <p>管理分类对应的图片和视频资源</p>
                <el-button type="success" @click="goToResources">进入资源管理</el-button>
              </div>
            </el-card>
          </el-col>
          <el-col :span="8">
            <el-card class="box-card">
              <div slot="header" class="clearfix">
                <span>首页轮播图</span>
              </div>
              <div class="card-content">
                <p>管理首页轮播图展示</p>
                <el-button type="warning" @click="goToHomeImages">进入轮播图管理</el-button>
              </div>
            </el-card>
          </el-col>
        </el-row>
        <el-row :gutter="20" style="margin-top: 20px;">
          <el-col :span="8">
            <el-card class="box-card">
              <div slot="header" class="clearfix">
                <span>系统配置</span>
              </div>
              <div class="card-content">
                <p>管理系统配置参数</p>
                <el-button type="info" @click="goToConfig">进入配置管理</el-button>
              </div>
            </el-card>
          </el-col>
        </el-row>
      </el-main>
    </el-container>
  </div>
</template>

<script>
import { clearAdminAuth } from '@/utils/auth'

export default {
  name: 'AdminDashboard',
  methods: {
    goToCategories() {
      this.$router.push('/categories')
    },
    goToResources() {
      this.$router.push('/resources')
    },
    goToHomeImages() {
      this.$router.push('/home-images')
    },
    goToConfig() {
      this.$router.push('/config')
    },
    goToChangePassword() {
      this.$router.push('/change-password')
    },
    handleLogout() {
      this.$confirm('确定要退出登录吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        // 清除认证信息
        clearAdminAuth()
        localStorage.removeItem('isLoggedIn')
        // 跳转到登录页
        this.$message.success('已退出登录')
        this.$router.push('/login')
      }).catch(() => {
        // 用户取消
      })
    }
  }
}
</script>

<style scoped>
.admin-dashboard {
  min-height: 100vh;
  background-color: #f5f5f5;
}

.el-header {
  background-color: #409EFF;
  color: white;
  padding: 0 20px;
  margin-bottom: 20px;
}

.header-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 100%;
}

.el-header h1 {
  margin: 0;
  font-size: 24px;
  line-height: 60px;
}

.header-actions {
  display: flex;
  gap: 10px;
}

.header-actions .el-button {
  color: white;
  padding: 0 15px;
}

.header-actions .el-button:hover {
  background-color: rgba(255, 255, 255, 0.1);
}

.box-card {
  margin-bottom: 20px;
  height: 100%;
}

.card-content {
  text-align: center;
  padding: 20px 0;
}

.card-content p {
  margin-bottom: 20px;
  color: #666;
}
</style>
